// A brief is dated the morning it goes out and describes the day before, so
// today's and yesterday's briefs are current. Anything older is history — the
// home page once showed a September 1 score as "Today's Score" on September 24.
const localDay = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function isCurrentBrief(briefDate: string | undefined | null, now: Date = new Date()): boolean {
  if (!briefDate) return false;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  return briefDate.slice(0, 10) >= localDay(yesterday);
}
